import { render, staticRenderFns } from "./FavoriteStore.vue?vue&type=template&id=bb2165a2&scoped=true&"
import script from "./FavoriteStore.vue?vue&type=script&lang=js&"
export * from "./FavoriteStore.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteStore.vue?vue&type=style&index=0&id=bb2165a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2165a2",
  null
  
)

export default component.exports